import { useMutation } from '@tanstack/react-query';
import type { RespondedType, ResponseError } from '@/models/response';
import { addToast } from '@/stores/toast';
import { fetcher } from '@/utils/fetcher';
import { queryClient } from '@/utils/query-client';
import { friendsQueryOptions } from '../contacts/use-friends';
import { blacklistQueryOptions } from './use-blacklist';

export default function useAddBlackList() {
  return useMutation<RespondedType, ResponseError, number>({
    mutationKey: ['/AddBlackList'],
    mutationFn: (params) => fetcher('/AddBlackList', { UserID: params }, { validResponseCodes: [0] }),
    onSuccess: () =>
      Promise.allSettled([
        queryClient.invalidateQueries(friendsQueryOptions),
        queryClient.invalidateQueries(blacklistQueryOptions),
      ]),
    onSettled: (data, error) =>
      addToast({
        type: data ? 'success' : 'error',
        message: data?.Msg ?? error?.message,
      }),
  });
}
